import ApiPaths from '../api-paths.js';

export default {
  store(data) {
    return axios.post(`${ ApiPaths.BOOKKEEPING }/invoice-partial-payments`, { invoicepartialpayment: data });
  },
};
